import React from 'react';
import { useSelector } from 'react-redux';
import { FullTable, AddCircleBlue } from 'components';
import { sortListByKey, useModal } from 'utils';
import { OVERTIME_ACTION, overtimeBody, overtimeHead } from './constants';
import { OvertimeSettings as OvertimeModal } from './modals';

export const OvertimeSettingsList = ({ }) => {
    const globalOvertimeSettings = useSelector((state) => state.payroll.overtimeSettings);
    const { close, open } = useModal();

    return (
        <div>
            <div className="header-action-btn">
                <AddCircleBlue text="Add Overtime Setting" handleClick={() => open(<OvertimeModal />)} />
            </div>
            <FullTable
                margin={'0'}
                head={overtimeHead}
                body={overtimeBody}
                loadingType={OVERTIME_ACTION}
                list={globalOvertimeSettings?.length ? sortListByKey(globalOvertimeSettings, 'name') : []}
                noText={'overtime settings'}
                handleClickButton={(i) => open(<OvertimeModal info={i} />)}
                height={'auto'}
            />
        </div>
    );
};
